import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import {
  FaUsers,
  FaUserCheck,
  FaClock,
  FaUserShield,
} from "react-icons/fa";
import { GiMedicines, GiArchiveResearch } from "react-icons/gi";
import { MdArticle } from "react-icons/md";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await api.get("/admin/stats", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setStats(res.data);
      } catch (err) {
        console.log("İstatistik çekilemedi", err);
      }
    };

    loadStats();
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    textAlign: "center",
  };

  return (
    <AdminLayout>
      <h2 className="mb-4">📊 Admin Dashboard</h2>

      {!stats ? (
        <p>Yükleniyor...</p>
      ) : (
        <div className="row g-4">

          {/* TOPLAM KULLANICI */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <FaUsers size={40} color="#2D8A7A" />
              <h2>{stats.totalUsers}</h2>
              <p className="text-muted">Toplam Kullanıcı</p>
            </div>
          </div>

          {/* ONAYLI */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <FaUserCheck size={40} color="#2D8A7A" />
              <h2>{stats.approvedUsers}</h2>
              <p className="text-muted">Onaylı Kullanıcı</p>
            </div>
          </div>

          {/* ONAY BEKLEYEN */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <FaClock size={40} color="#2D8A7A" />
              <h2>{stats.pendingUsers}</h2>
              <p className="text-muted">Onay Bekleyen</p>
            </div>
          </div>

          {/* ADMİN SAYISI */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <FaUserShield size={40} color="#2D8A7A" />
              <h2>{stats.adminUsers}</h2>
              <p className="text-muted">Admin Sayısı</p>
            </div>
          </div>

          {/* TOPLAM FORMÜL */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <GiMedicines size={40} color="#2D8A7A" />
              <h2>{stats.totalFormulas}</h2>
              <p className="text-muted">Toplam Formül</p>
            </div>
          </div>

          {/* HASTALIK SAYISI */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <GiArchiveResearch size={40} color="#2D8A7A" />
              <h2>{stats.totalDiseases}</h2>
              <p className="text-muted">Hastalık Kayıtları</p>
            </div>
          </div>

          {/* BLOG SAYISI */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <MdArticle size={40} color="#2D8A7A" />
              <h2>{stats.totalBlogs}</h2>
              <p className="text-muted">Blog Yazıları</p>
            </div>
          </div>

          {/* SON 7 GÜN */}
          <div className="col-md-3">
            <div style={cardStyle}>
              <FaUsers size={40} color="#2D8A7A" />
              <h2>{stats.recentUsersLast7Days}</h2>
              <p className="text-muted">Son 7 Günde Kayıt Olan</p>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminDashboard;
